import React from "react";

const Strategy = () => {
  const pageStyle = {
    backgroundColor: "#05070a",
    color: "#ffffff",
    minHeight: "100vh",
    paddingTop: "140px",
    paddingBottom: "100px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  };

  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  };

  const glassCard = {
    background: "rgba(255, 255, 255, 0.03)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "24px",
    padding: "40px",
    backdropFilter: "blur(10px)",
    height: "100%",
  };

  const badge = {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    background: "rgba(0, 212, 255, 0.1)",
    color: "#00d4ff",
    fontSize: "0.85rem",
    fontWeight: "bold",
    marginRight: "10px",
    marginBottom: "10px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
  };

  return (
    <div style={pageStyle}>
      <div style={container}>
        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: "90px" }}>
          <h1 style={{ fontSize: "3.5rem", fontWeight: "800", marginBottom: "20px" }}>
            Enterprise <span style={{ color: "#00d4ff" }}>Strategy</span> & Delivery Governance
          </h1>
          <p
            style={{
              fontSize: "1.2rem",
              color: "#8b949e",
              maxWidth: "900px",
              margin: "0 auto",
              lineHeight: "1.8",
            }}
          >
            Digital-X-AI partners with enterprises and system integrators to define,
            execute, and scale technology programs through structured delivery
            strategy, strong governance, and reliable execution models.
          </p>
        </div>

        {/* STRATEGY HERO */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(450px, 1fr))",
            gap: "60px",
            alignItems: "center",
            marginBottom: "110px",
          }}
        >
          <div>
            <img
              src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80"
              alt="Enterprise Strategy"
              style={{
                width: "100%",
                borderRadius: "30px",
                border: "1px solid #30363d",
                boxShadow: "0 25px 50px rgba(0,0,0,0.45)",
              }}
            />
          </div>

          <div style={glassCard}>
            <h2 style={{ color: "#00d4ff", marginBottom: "20px" }}>
              Strategy Built for Execution
            </h2>
            <p style={{ color: "#8b949e", lineHeight: "1.8", marginBottom: "25px" }}>
              Our strategy approach is deeply execution-oriented. We align business
              objectives, delivery timelines, and resource capabilities to ensure
              programs move from planning to production without friction.
            </p>
            <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
              Digital-X-AI operates as a strategic extension of your delivery
              organization, ensuring accountability, transparency, and consistent
              outcomes.
            </p>
          </div>
        </div>

        {/* STRATEGIC PILLARS */}
        <div style={{ marginBottom: "110px" }}>
          <h2 style={{ textAlign: "center", marginBottom: "60px", fontSize: "3rem" }}>
            Our Strategic Pillars
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "30px",
            }}
          >
            <div style={glassCard}>
              <h3 style={{ color: "#00d4ff" }}>Delivery Governance</h3>
              <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
                Structured governance models, reporting frameworks, and quality
                checkpoints to ensure enterprise-grade delivery across all
                engagements.
              </p>
            </div>

            <div style={glassCard}>
              <h3 style={{ color: "#00d4ff" }}>Scalable Resource Strategy</h3>
              <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
                Rapid scaling through pre-vetted resources across cloud,
                integration, data, and enterprise platforms, aligned with
                business priorities.
              </p>
            </div>

            <div style={glassCard}>
              <h3 style={{ color: "#00d4ff" }}>Risk & Dependency Management</h3>
              <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
                Proactive identification of delivery risks, technical dependencies,
                and resourcing gaps to protect timelines and budgets.
              </p>
            </div>

            <div style={glassCard}>
              <h3 style={{ color: "#00d4ff" }}>Long-Term Value Creation</h3>
              <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
                Focus on sustainable architectures, knowledge transfer, and
                operational stability beyond go-live milestones.
              </p>
            </div>
          </div>
        </div>

        {/* INDIA–MIDDLE EAST STRATEGY */}
        <div
          style={{
            background: "rgba(0, 212, 255, 0.05)",
            borderRadius: "40px",
            padding: "70px",
            border: "1px solid rgba(0, 212, 255, 0.2)",
            marginBottom: "110px",
            display: "flex",
            gap: "50px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1, minWidth: "300px" }}>
            <h2 style={{ fontSize: "2.6rem" }}>
              India–Middle East <span style={{ color: "#00d4ff" }}>Execution Model</span>
            </h2>
            <p style={{ color: "#8b949e", lineHeight: "1.9", marginTop: "20px" }}>
              Our strategic delivery corridor leverages India-based engineering
              excellence combined with regional coordination in the Middle East.
              This enables speed, cost efficiency, and continuous delivery.
            </p>

            <div style={{ marginTop: "25px" }}>
              <span style={badge}>Sub-Contracting</span>
              <span style={badge}>Program Ownership</span>
              <span style={badge}>Time-Zone Coverage</span>
              <span style={badge}>Enterprise SLAs</span>
            </div>
          </div>

          <div style={{ flex: 1, minWidth: "300px" }}>
            <img
              src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=900&q=80"
              alt="Global Execution Model"
              style={{ width: "100%", borderRadius: "25px" }}
            />
          </div>
        </div>

        {/* SUBLET STRATEGY */}
        <div style={{ textAlign: "center" }}>
          <h2 style={{ fontSize: "2.8rem", marginBottom: "25px" }}>
            A Strategic <span style={{ color: "#00d4ff" }}>Sub-Delivery</span> Partner
          </h2>
          <p
            style={{
              color: "#8b949e",
              fontSize: "1.15rem",
              maxWidth: "900px",
              margin: "0 auto",
              lineHeight: "1.9",
            }}
          >
            Digital-X-AI is not a transactional vendor. We integrate into your
            delivery ecosystem as a sub-delivery partner, operating under shared
            goals, governance, and accountability to ensure successful outcomes
            across programs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Strategy;